import { Gradient } from '@rouvydev/web-components/gradients'
import { Logo } from '~/components/logo.tsx'
import { type FeaturedLogoFragment } from '~/model/api.ts'

type LogoProps = {
  title: string
  image: string
  link?: string
}

type FeaturedLogoProps = {
  title: string
  logo: LogoProps
  className?: string
}

export function prepareFeaturedLogoProps(
  data: FeaturedLogoFragment,
): FeaturedLogoProps {
  const { title, image, link } = data.featuredLogo

  return {
    title,
    logo: {
      title,
      image: image.data?.attributes?.url ?? '',
      link: link ?? undefined,
    },
  }
}

export function FeaturedLogo({ title, logo, className }: FeaturedLogoProps) {
  return (
    <Gradient variant="2" className={className}>
      <div className="container mx-auto flex flex-col items-center justify-center gap-6 px-6 py-12 md:flex-row md:py-20 lg:px-8">
        <div className="text-center font-display text-display-28 leading-none font-bold text-global-white uppercase italic">
          {title}
        </div>
        <Logo
          title={logo.title}
          image={logo.image}
          link={logo.link}
          className="max-h-[120px] max-w-36"
        />
      </div>
    </Gradient>
  )
}
